import React from "react";
import Button from "react-bootstrap/Button";
import { MdArrowBack } from "react-icons/md";

const ListHeaderBackButton = ({ onClick, ariaLabel = "Back to list" }) => (
  <div className="list-header-back-btn-wrap">
    <Button
      type="button"
      variant="link"
      className="list-header-back-btn"
      onClick={onClick}
      aria-label={ariaLabel}
      data-testid="list-header-back-btn"
    >
      <MdArrowBack aria-hidden="true" size={22} />
    </Button>
    <span className="list-header-back-btn-divider" aria-hidden="true" />
  </div>
);

export default ListHeaderBackButton;
